import { useApiSend } from '../../shared/api/utils/reactQueryProvider';
import { addRideNote } from '../api/services/Rides';
import { RideNotesPayload } from '../types/rides';

interface iUseRideNotesSubmit {
  rideSlug: string;
  successCallback?: () => void;
  errorCallback?: (error: Error) => void;
}

export const useRideNotesSubmit = ({ rideSlug, successCallback, errorCallback }: iUseRideNotesSubmit) => {
  return useApiSend(
    (payload: RideNotesPayload) => addRideNote(rideSlug, payload),
    successCallback,
    errorCallback,
    ['rideNotes'],
    undefined
  );
};
